import * as Long from "long";
import { IdEvent } from "../constants/IdEvents";
import { selectEventEndTime, selectEventInfoByTypeId, selectIsEventExpired, selectIsEventRunning, } from "./selectEventInfo";
export var selectTraderEventDetails = function (state) {
    return state.eventInfo.traderEvent;
};
export var selectTraderEventTradeDetails = function (state) {
    var eventInfo = selectEventInfoByTypeId(state, IdEvent.Trader);
    if (eventInfo == undefined || selectIsEventExpired(eventInfo[0])) {
        return;
    }
    var traderEventInfo = state.traderEventInfo;
    var reward = traderEventInfo.reward[0];
    var trade = traderEventInfo.trade;
    var traderEventPackages = trade.map(function (tradeItem) {
        var tradeItemCost = tradeItem.cost[0];
        var tradeItemReward = tradeItem.reward[0];
        var id = tradeItem.offerId || 0;
        var newPrice = tradeItemCost.amount || Long.ZERO;
        var oldPrice = Long.fromValue(Math.round((newPrice.toNumber() / (100 - tradeItem.discount)) * 100));
        var isPurchased = tradeItem.boughtAmount >= tradeItem.maxPurchases;
        var discount = tradeItem.discount || 0;
        return {
            discount: discount,
            id: id,
            isPurchased: isPurchased,
            newPrice: newPrice,
            oldPrice: oldPrice,
            tradeItemCost: tradeItemCost,
            tradeItemReward: tradeItemReward,
        };
    });
    return { reward: reward, traderEventPackages: traderEventPackages };
};
export var selectTraderEventRemainingTime = function (state) {
    var traderEventDetails = selectTraderEventDetails(state);
    if (traderEventDetails && traderEventDetails[0]) {
        return selectEventEndTime(traderEventDetails[0]);
    }
    return 0;
};
export var selectIsTraderEventRunning = function (state) {
    var eventInfo = selectEventInfoByTypeId(state, IdEvent.Trader);
    if (eventInfo) {
        return selectIsEventRunning(eventInfo.proto);
    }
    return false;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectTraderEventInfo.ts
// module id = 304
// module chunks = 3